import type { ToothSliceOptionsBySeries } from '../config';
import { TOOTH_BASIS_SERIES_ORDER } from '../config';

const resolveThicknessMm = ({
  optionsMm,
  thicknessMm,
}: {
  optionsMm: number[];
  thicknessMm: number;
}): number => {
  if (!optionsMm.length) {
    return thicknessMm;
  }

  return (
    optionsMm.find((optionMm) => optionMm >= thicknessMm) ??
    optionsMm[optionsMm.length - 1]
  );
};

export const resolveToothSliceOptionsBySeries = ({
  optionsBySeries,
  thicknessOptionsMm,
}: {
  optionsBySeries: ToothSliceOptionsBySeries;
  thicknessOptionsMm: number[];
}): ToothSliceOptionsBySeries =>
  TOOTH_BASIS_SERIES_ORDER.reduce((resolved, seriesName) => {
    const options = optionsBySeries[seriesName];

    return {
      ...resolved,
      [seriesName]: {
        ...options,
        thicknessMm: resolveThicknessMm({
          optionsMm: thicknessOptionsMm,
          thicknessMm: options.thicknessMm,
        }),
      },
    };
  }, {} as ToothSliceOptionsBySeries);
